/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

export const adjustAcceptedRedirect = (locale: string, acceptedRedirect?: string): string => {
	if (!acceptedRedirect) return "";

	if (locale && !acceptedRedirect.includes("?")) {
		const underscoreLocale = locale.replace("-", "_");
		return `${acceptedRedirect}?language=${underscoreLocale}`;
	}

	return acceptedRedirect;
};
